import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SelectList } from "ui";

import { TRANSACTIONS_STATUSES_LIST } from "../../../../constants";
import { FilterFormValues } from "../TransactionsFilterForm.types";

import styles from "../TransactionsFilterForm.module.scss";

export const StatusBlock = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles["filter-form__statuses"]}>
      <h4 className={styles["filter-form__statuses--title"]}>{t("Status")}</h4>

      <div className={styles["filter-form__statuses--selector"]}>
        <Controller
          control={control}
          name="statuses"
          render={({ field: { onChange, value } }) => (
            <SelectList
              value={value}
              onChange={onChange}
              options={TRANSACTIONS_STATUSES_LIST}
            />
          )}
        />
      </div>
    </div>
  );
};
